import { render, staticRenderFns } from "./Socialauth.vue?vue&type=template&id=5083cd67"
import script from "./Socialauth.vue?vue&type=script&lang=js"
export * from "./Socialauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports